import { ActionService } from '@acme/api';
import { Icon } from '@acme/assets';
import { AddWalletAddressesFormConfig } from '@acme/domains';
import {
  Form,
  FormControls,
  Separator,
  useFormModel,
  type FormConfig,
} from '@acme/foundation';
import { Alert, Button } from 'flowbite-react';
import { useMemo, useState } from 'react';

const VALIDATION_ERROR_MESSAGE = 'Не прошла валидация';

type WalletAddressesModel = Record<string, string>;

interface AddWalletAddressesFormProps {
  closeModal: () => void;
  actionId: string;
}
export const AddWalletAddressesForm = ({
  closeModal,
  actionId,
}: AddWalletAddressesFormProps) => {
  const [wallets, setWallets] = useState<number>(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAddWallet = () => {
    setWallets((prev) => prev + 1);
  };

  const formConfig = useMemo(() => {
    return AddWalletAddressesFormConfig(
      true,
      wallets
    ) as unknown as FormConfig<WalletAddressesModel>;
  }, [wallets]);

  const form = useFormModel<WalletAddressesModel>({
    config: formConfig,
    ctx: {} as WalletAddressesModel,
  });

  const onSubmit = async (m: WalletAddressesModel) => {
    const walletAddresses: string[] = [];

    for (let i = 0; i < wallets; i++) {
      walletAddresses.push(m[`wallet-${i}`] ?? '');
    }

    setError(null);
    setIsSubmitting(true);
    try {
      const res = await ActionService.postApiV1ActionFormWalletsWhichTransfer({
        id: actionId,
        formData: {
          walletAddresses: walletAddresses,
          comment: '',
        },
      });

      if (res.isSuccess) {
        closeModal();
      } else if (res.errorCode === 400) {
        setError(VALIDATION_ERROR_MESSAGE);
      } else {
        setError(res.errorText ?? VALIDATION_ERROR_MESSAGE);
      }
    } catch {
      setError(VALIDATION_ERROR_MESSAGE);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form form={form} onSubmit={onSubmit}>
      <div className="flex flex-col gap-6">
        {error && <Alert color="failure">{error}</Alert>}
        <span>
          Введите адрес криптокошелька, с которого планируется перевод
        </span>

        <FormControls form={form} />

        <div
          onClick={handleAddWallet}
          className="flex gap-1 items-center text-brand-purple-900 cursor-pointer"
        >
          <Icon name="plus-outline" size={16} />
          Добавить адрес криптокошелька
        </div>

        <Separator className="-mx-6" />

        <div className="flex gap-2">
          <Button type="submit" color="primary" disabled={isSubmitting}>
            Подтвердить
          </Button>

          <Button
            onClick={closeModal}
            color="alternative"
            disabled={isSubmitting}
          >
            Отмена
          </Button>
        </div>
      </div>
    </Form>
  );
};
